import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import StackView from '../StackView';
import { cloneChildren } from '../utils';
import ListItem from './ListItem';

function List(_ref) {
  var border = _ref.border,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? 'separatorTertiary' : _ref$borderColor,
      children = _ref.children,
      _ref$divider = _ref.divider,
      divider = _ref$divider === void 0 ? true : _ref$divider,
      _ref$dividerColor = _ref.dividerColor,
      dividerColor = _ref$dividerColor === void 0 ? 'separatorTertiary' : _ref$dividerColor,
      onItemRemoveRequest = _ref.onItemRemoveRequest,
      restProps = _objectWithoutPropertiesLoose(_ref, ["border", "borderColor", "children", "divider", "dividerColor", "onItemRemoveRequest"]);

  if (border) {
    restProps.borderTopWidth = 1;
    restProps.borderTopColor = borderColor;
    restProps.borderBottomWidth = 1;
    restProps.borderBottomColor = borderColor;
  }

  return /*#__PURE__*/React.createElement(StackView, restProps, cloneChildren(children, function (child, _ref2) {
    var index = _ref2.index,
        lastChild = _ref2.lastChild;
    var childProps = divider && !lastChild ? {
      borderBottomWidth: 1,
      borderBottomColor: dividerColor
    } : {};

    if (onItemRemoveRequest || child.props.onRemoveRequest) {
      childProps.onRemoveRequest = function () {
        if (onItemRemoveRequest) {
          onItemRemoveRequest(index);
        }

        if (child.props.onRemoveRequest) {
          child.props.onRemoveRequest(index);
        }
      };
    }

    return childProps;
  }));
}

List.Item = ListItem;
export default List;